import { APP_VERSION } from '../lib/version'

// M55 maker's mark. Two variants:
//
//   variant="footer"  — compact badge for the auth page footer.
//   variant="about"   — full About block for the in-app Settings tab.
//
// Logo is the original navy artwork in /m55_logo.png. To stay neutral
// against the Anubis zone themes the dark-theme rendering applies
// brightness(0) invert(1) which forces it to a flat white silhouette;
// FLARE drops the invert so it lands as pure ink-black on the bone-white
// FLARE background (see .flare m55-mark override in theme-flare.css).
// Hover lifts opacity from 0.5 to 1 so the mark reads as a deliberate
// maker's mark rather than an interactive ad.

const LOGO_SRC = '/m55_logo.png'

const baseLogoStyle = {
  display: 'block',
  margin: '0 auto',
  filter: 'brightness(0) invert(1)',
  opacity: 0.5,
  transition: 'opacity 120ms ease',
}

const linkStyle = {
  display: 'block',
  textAlign: 'center',
  textDecoration: 'none',
  color: 'inherit',
}

export default function M55Mark({ variant = 'footer' }) {
  if (variant === 'footer') {
    return (
      <a
        href="https://m55.dev"
        target="_blank"
        rel="noopener noreferrer"
        className="m55-mark"
        style={{ ...linkStyle, marginTop: 32 }}
        onMouseEnter={e => { const img = e.currentTarget.querySelector('img'); if (img) img.style.opacity = '1' }}
        onMouseLeave={e => { const img = e.currentTarget.querySelector('img'); if (img) img.style.opacity = '0.5' }}
      >
        <img src={LOGO_SRC} alt="M55" style={{ ...baseLogoStyle, height: 44, width: 'auto' }} />
        <p style={{
          fontFamily: "'Saira Condensed', 'Rajdhani', sans-serif",
          fontSize: 10,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: '#5a6470',
          margin: '8px 0 0',
        }}>An M55 Product</p>
      </a>
    )
  }

  // variant === 'about'
  return (
    <div className="m55-mark" style={{ textAlign: 'center', padding: '24px 16px', marginTop: 24 }}>
      <a
        href="https://m55.dev"
        target="_blank"
        rel="noopener noreferrer"
        style={linkStyle}
        onMouseEnter={e => { const img = e.currentTarget.querySelector('img'); if (img) img.style.opacity = '1' }}
        onMouseLeave={e => { const img = e.currentTarget.querySelector('img'); if (img) img.style.opacity = '0.5' }}
      >
        <img src={LOGO_SRC} alt="M55" style={{ ...baseLogoStyle, height: 56, width: 'auto' }} />
      </a>
      <p style={{
        fontFamily: "'Saira Condensed', 'Rajdhani', sans-serif",
        fontSize: 12,
        color: '#9aa6b0',
        margin: '12px 0 4px',
        lineHeight: 1.5,
      }}>
        Anubis is a product of M55 — Mothership 5ystem 5olutions
      </p>
      <p style={{
        fontFamily: "'JetBrains Mono', 'Saira Condensed', monospace",
        fontSize: 10,
        letterSpacing: '0.08em',
        color: '#5a6470',
        margin: '0 0 8px',
      }}>v{APP_VERSION}</p>
      <a
        href="https://m55.dev"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          fontFamily: "'Saira Condensed', 'Rajdhani', sans-serif",
          fontSize: 11,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: '#ff7a18',
          textDecoration: 'none',
          marginTop: 4,
        }}
      >m55.dev →</a>
    </div>
  )
}
